import { takeLatest, put, call } from 'redux-saga/effects';
import { getAdminsActions } from './slice';
import {
  getAllAdmins,
  deleteAdmin,
  getMasterAdmin,
  changeMasterAdmin,
} from './functions';

function* getAdminsReference() {
  try {
    const response = yield call(getAllAdmins);
    yield put(getAdminsActions.getAdminsSuccess(response));
  } catch (error) {
    yield put(getAdminsActions.getAdminsError(error));
  }
}
//
function* removeAdminsReference({ payload }) {
  try {
    const response = yield call(deleteAdmin, payload);
    yield put(getAdminsActions.removeAdminsSuccess(response));
  } catch (error) {
    yield put(getAdminsActions.removeAdminsError(error));
  }
}
//
function* getMasterReference() {
  try {
    const response = yield call(getMasterAdmin);
    yield put(getAdminsActions.getMasterAdminsSuccess(response));
  } catch (error) {
    yield put(getAdminsActions.getMasterAdminsError(error));
  }
}
//
function* changeMasterReference({ payload }) {
  try {
    const response = yield call(changeMasterAdmin, payload);
    yield put(getAdminsActions.changeAdminsSuccess(response));
  } catch (error) {
    yield put(getAdminsActions.changeAdminsError(error));
  }
}
//
function* getAdminsSaga() {
  yield takeLatest(getAdminsActions.getAdmins.type, getAdminsReference);
  yield takeLatest(getAdminsActions.removeAdmins.type, removeAdminsReference);
  yield takeLatest(getAdminsActions.getMasterAdmin.type, getMasterReference);
  yield takeLatest(getAdminsActions.changeAdmins.type, changeMasterReference);
}
//
export default getAdminsSaga;
